module.exports = __webpack_public_path__ + "static/media/grid-item-c5.cef64871.png";